import "./Theme.scss";

export const ThemeSelector = ({ theme, setTheme, t }) => (
  <select
    className={`themeSelector px-3 py-2 rounded-md text-sm font-medium border ${
      theme === "light"
        ? "bg-white text-black border-gray-400"
        : "bg-gray-800 text-white border-gray-600"
    }`}
    value={theme}
    onChange={(e) => setTheme(e.target.value)}
  >
    <option value="light" className="bg-white text-black">
      {t("common:intents.flow_chat.theme.light")}
    </option>
    <option value="dark" className="bg-gray-800 text-white">
      {t("common:intents.flow_chat.theme.dark")}
    </option>
  </select>
);
